<template>
  <div class="account-page py-4 mt-4">
    <div class="container">
      <div class="w-full main-card px-3 md:px-4 lg:px-5 py-4 lg:py-5 xl:py-7">
        <h1>Old Campaigns</h1>
        <div><OldCampaignsTable /></div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import CustumInput from '@/components/shared/form/CustumInput.vue';
import { Col, Row, TabPane, Tabs } from 'ant-design-vue';
import OldCampaignsTable from './OldCampaignsTable.vue';

export default {
  components: {
    CustumInput,
    Col,
    Row,
    Tabs,
    TabPane,
    OldCampaignsTable,
  },
  data() {
    return {
      formData: {},
    };
  },
  created() {},
  computed: {},
  methods: {
    setInput(vals) {
      this.formData = { ...this.formData, ...vals };
    },
  },
};
</script>
